// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MBzsT","footerText":"Footer_footerText__C6iC2","footerImage":"Footer_footerImage__bgUbE","terms":"Footer_terms__3QYDY"};